import auth from './auth';
import error from './error';
import http from './http';

const links = { error, auth, http };

export default links;
